import React from 'react';
import { Dialog } from './Dialog';
interface HostSalonDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export const HostSalonDialog = ({
  isOpen,
  onClose
}: HostSalonDialogProps) => {
  return <Dialog isOpen={isOpen} onClose={onClose} title="Host a Salon / Become a City Lead" size="xl" data-id="element-1400" data-mp="20ehyqx22kncc">
      <div className="w-full" data-id="element-1401" data-mp="1vn9ojysx0xy4">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc2pQt4IlWK2OHNjmC1_uM99NEJ2VP49XbIiIBuOKMxas42bQ/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-1402" data-mp="1vlyooa2lcaca">
          Loading…
        </iframe>
      </div>
    </Dialog>;
};